// Didn't have much luck getting 'scroll-behavior' (React plugin) to work and it seems unecessarily complex,
// so created this very simple plugin to provide explicit control over scroll behaviour.
//
// See comments below for usage

import { browserHistory } from 'react-router'

browserHistory.listen(function(loc) {
    // Don't scroll if it's a pop event (ex: browser back button, or window.history.back())
    if (loc.action === 'POP' || loc.action === 'REPLACE') {
        return;
    }

    // Don't scroll if we set location.state.scroll to false
    // e.g. with history.replaceState({ scroll: false }, path); or <Link to={path} state={{ scroll: false }}>
    if (loc.state && loc.state.scroll === false) {
        return;
    }

    // Otherwise, scroll to the top after a few milliseconds.
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 200);
});


export { browserHistory };



// WEBPACK FOOTER //
// ./src/global/history.jsx